import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LogOut from './LogOut.jsx';
import './styles/ProfileMenu.css';
import PropTypes from "prop-types";
import { getSessionEmail } from '../Auth/authSession.js';
import { fetchHousePasses } from '../api/housePasses.js';

export default function ProfileMenuItems({ onItemClick }) {
    const roleId = localStorage.getItem('roleId');
    const email = getSessionEmail();
    const [housePasses, setHousePasses] = useState(null);
    let role = "";

    switch (roleId) {
        case '1':
            role = "Free";
            break;
        case '2':
            role = "SmallPack";
            break;
        case '3':
            role = "Standard";
            break;
        case '4':
            role = "Premium";
            break;
    }

    useEffect(() => {
        if (roleId !== '1') {
            return undefined;
        }

        let cancelled = false;
        fetchHousePasses()
            .then((data) => {
                if (cancelled || !data) {
                    return;
                }
                if (data.remaining == null || data.limit == null) {
                    return;
                }
                const remaining = Number(data.remaining);
                const limit = Number(data.limit);
                if (!Number.isFinite(remaining) || !Number.isFinite(limit)) {
                    return;
                }
                setHousePasses({ remaining, limit });
            })
            .catch(() => {
                // Quiet failure: the menu stays usable without the pass count.
            });

        return () => {
            cancelled = true;
        };
    }, [roleId]);

    const handleItemClick = () => {
        if (onItemClick) onItemClick();
    };

    return (
        <>
            <div className="header__profile-section">
                {roleId === '4'
                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 20H19M2 4L5 16H19L22 4L16 11L12 4L8 11L2 4Z" stroke="#DACBB7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                }

                <div className={"header__user-data"}>
                    <p>{role} Account</p>
                    <p>{email}</p>
                    {roleId === '1' && housePasses ? (
                        <p className="header__house-passes">
                            House Passes: {housePasses.remaining} of {housePasses.limit} left
                        </p>
                    ) : null}
                </div>
            </div>
            <div className={"header__line"}></div>
            <Link to="/contact-us" className="header__profile-menu-item" onClick={handleItemClick}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_profile_help)">
                        <path d="M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337Z" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M7.57422 7.50047C7.77014 6.94353 8.15685 6.4739 8.66585 6.17475C9.17485 5.87561 9.7733 5.76626 10.3552 5.86607C10.9371 5.96588 11.4649 6.26841 11.8451 6.72008C12.2253 7.17175 12.4334 7.74341 12.4326 8.33381C12.4326 10.0005 9.93255 10.8338 9.93255 10.8338" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 14.167H10.0083" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_profile_help">
                            <rect width="20" height="20" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
                Help & Support
            </Link>
            <div className={"header__line"}></div>
            <Link to="/settings/user-profile" className="header__profile-menu-item" onClick={handleItemClick}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.1824 1.66699H9.81569C9.37366 1.66699 8.94974 1.84259 8.63718 2.15515C8.32462 2.46771 8.14903 2.89163 8.14903 3.33366V3.48366C8.14873 3.77593 8.07157 4.06298 7.92531 4.31602C7.77904 4.56906 7.56881 4.77919 7.31569 4.92533L6.95736 5.13366C6.70399 5.27994 6.41659 5.35695 6.12403 5.35695C5.83146 5.35695 5.54406 5.27994 5.29069 5.13366L5.16569 5.06699C4.78325 4.84638 4.32889 4.78653 3.90236 4.90058C3.47583 5.01464 3.11198 5.29327 2.89069 5.67533L2.70736 5.99199C2.48674 6.37444 2.42689 6.8288 2.54095 7.25532C2.655 7.68185 2.93364 8.0457 3.31569 8.26699L3.44069 8.35033C3.69259 8.49575 3.90204 8.70457 4.04823 8.95602C4.19443 9.20747 4.27227 9.4928 4.27403 9.78366V10.2087C4.27519 10.5023 4.19873 10.7911 4.05239 11.0457C3.90606 11.3004 3.69503 11.5118 3.44069 11.6587L3.31569 11.7337C2.93364 11.955 2.655 12.3188 2.54095 12.7453C2.42689 13.1719 2.48674 13.6262 2.70736 14.0087L2.89069 14.3253C3.11198 14.7074 3.47583 14.986 3.90236 15.1001C4.32889 15.2141 4.78325 15.1543 5.16569 14.9337L5.29069 14.867C5.54406 14.7207 5.83146 14.6437 6.12403 14.6437C6.41659 14.6437 6.70399 14.7207 6.95736 14.867L7.31569 15.0753C7.56881 15.2215 7.77904 15.4316 7.92531 15.6846C8.07157 15.9377 8.14873 16.2247 8.14903 16.517V16.667C8.14903 17.109 8.32462 17.5329 8.63718 17.8455C8.94974 18.1581 9.37366 18.3337 9.81569 18.3337H10.1824C10.6244 18.3337 11.0483 18.1581 11.3609 17.8455C11.6734 17.5329 11.849 17.109 11.849 16.667V16.517C11.8493 16.2247 11.9265 15.9377 12.0727 15.6846C12.219 15.4316 12.4292 15.2215 12.6824 15.0753L13.0407 14.867C13.2941 14.7207 13.5815 14.6437 13.874 14.6437C14.1666 14.6437 14.454 14.7207 14.7074 14.867L14.8324 14.9337C15.2148 15.1543 15.6692 15.2141 16.0957 15.1001C16.5222 14.986 16.8861 14.7074 17.1074 14.3253L17.2907 14.0003C17.5113 13.6179 17.5712 13.1635 17.4571 12.737C17.343 12.3105 17.0644 11.9466 16.6824 11.7253L16.5574 11.6587C16.303 11.5118 16.092 11.3004 15.9457 11.0457C15.7993 10.7911 15.7229 10.5023 15.724 10.2087V9.79199C15.7229 9.49831 15.7993 9.20953 15.9457 8.9549C16.092 8.70027 16.303 8.48883 16.5574 8.34199L16.6824 8.26699C17.0644 8.0457 17.343 7.68185 17.4571 7.25532C17.5712 6.8288 17.5113 6.37444 17.2907 5.99199L17.1074 5.67533C16.8861 5.29327 16.5222 5.01464 16.0957 4.90058C15.6692 4.78653 15.2148 4.84638 14.8324 5.06699L14.7074 5.13366C14.454 5.27994 14.1666 5.35695 13.874 5.35695C13.5815 5.35695 13.2941 5.27994 13.0407 5.13366L12.6824 4.92533C12.4292 4.77919 12.219 4.56906 12.0727 4.31602C11.9265 4.06298 11.8493 3.77593 11.849 3.48366V3.33366C11.849 2.89163 11.6734 2.46771 11.3609 2.15515C11.0483 1.84259 10.6244 1.66699 10.1824 1.66699Z" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="white" strokeOpacity="0.6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Settings
            </Link>
            <div className={"header__line"}></div>
            <LogOut onBeforeLogOut={onItemClick}/>
        </>
    );
}

ProfileMenuItems.propTypes = {
    onItemClick: PropTypes.func,
};
